// Inject missing vite assets from ajax response into current page
const injectMissingAssets = (parsedDocument) => {
  const vitePattern = /^\/_assets\/vite\/assets\//;

  parsedDocument.querySelectorAll('link[rel="stylesheet"][href]').forEach(link => {
    if (!vitePattern.test(link.getAttribute('href'))) return;
    if (!document.querySelector(`link[href="${link.getAttribute('href')}"]`)) {
      document.head.appendChild(link.cloneNode());
    }
  });

  parsedDocument.querySelectorAll('script[type="module"][src]').forEach(script => {
    if (!vitePattern.test(script.getAttribute('src'))) return;
    if (!document.querySelector(`script[src="${script.getAttribute('src')}"]`)) {
      const newScript = document.createElement('script');
      newScript.type = 'module';
      newScript.src = script.getAttribute('src');
      const nonce = script.getAttribute('nonce');
      if (nonce) newScript.setAttribute('nonce', nonce);
      document.head.appendChild(newScript);
    }
  });
};

// Function to open modal and load content
const openModal = (link) => {
  const cid = link.getAttribute('data-cid');
  const modal = document.getElementById('content-modal');
  const loadingIndicator = document.getElementById('loading-indicator');
  let modalContent = document.getElementById('content-modal-content');

  // Show loading indicator
  loadingIndicator.style.display = 'block';

  // Load content from href of the clicked link
  fetch(link.href)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const parsedDocument = parser.parseFromString(html, 'text/html');
      injectMissingAssets(parsedDocument);
      modalContent.innerHTML = html;

      // Search for element with the same id as cid in the modal content
      const elementInModal = modalContent.querySelector(`#c${cid}`);
      if(elementInModal) {
        // Load friendly captcha js
        const friendlycaptcha = modalContent.querySelector('script[src*="99f99e76d2a79baa40bc399c2e8cb79e"]');
        // Replace modal content with required data
        modalContent.innerHTML = '';
        modalContent.append(elementInModal);
        if (modalContent) {
          // Display modal
          modal.classList.add('content-modal-active');
          document.body.classList.add('modal-open'); // Prevent scrolling on background
          loadingIndicator.style.display = 'none'; // Hide loading indicator

          // Handle form submission if form exists in modal content
          const form = modalContent.querySelector('form');
          if (form) {
            form.addEventListener('submit', (event) => {
              handleForm(event, form, modalContent, cid)
            });
            if (friendlycaptcha) {
              let fcscript = document.createElement('script')
              fcscript.src = friendlycaptcha.src
              document.body.appendChild(fcscript);
            }
          }
        } else {
          console.error(`Element with id ${cid} not found in modal content.`);
        }
      }
    })
    .catch(error => console.error('Error loading content:', error));
};

// Close modal function
const closeModal = () => {
  const modal = document.getElementById('content-modal');
  modal.classList.remove('content-modal-active');
  document.body.classList.remove('modal-open');
};

// Handle form submits inside modal
const handleForm = (event, form, modalContent, cid) => {
  event.preventDefault();
  const submitButton = event.submitter; // Get the clicked submit button
  const submitValue = submitButton.value;
  const submitName = submitButton.name;
  const formData = new FormData(form),
    formId = form.id;
  formData.append(submitName, submitValue);
  fetch(form.action, {
    method: form.method,
    body: formData
  })
    .then(response => response.text())
    .then(responseHtml => {
      const responseElement = document.createElement('div');
      responseElement.innerHTML = responseHtml;
      const responseContent = responseElement.querySelector(`#${formId}`);

      if (responseContent) {
        modalContent.innerHTML = responseContent.innerHTML;
        const responseForm = modalContent.querySelector('form');
        if (responseForm) {
          responseForm.addEventListener('submit', (responseEvent) => {
            handleForm(responseEvent, responseForm, modalContent, cid)
          });
        }
      } else {
        console.error(`Element with id ${cid} not found in response.`);
      }
    })
    .catch(error => console.error('Error submitting form:', error));
}

// Register modal eventlistener
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('content-modal');
  // Get all links with data-cid attribute
  const links = document.querySelectorAll('[data-cid]');
  if (!links || !modal) {
    return
  }
  // Attach click event listener to each link
  links.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      openModal(link);
    });
  });

  // Close modal when clicking outside of it
  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  // Close modal when close button is clicked
  const closeButton = document.getElementById('content-modal-close');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeModal();
    });
  }

  // Close modal when pressing the Esc key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
});
